var EHDI = EHDI || Object.create(null);

EHDI.GameStateEnum = {
  GAMEINITIALIZING: 0,
  GAMESTARTED: 1,
  GAMEPAUSED: 2,
  GAMERESUMED: 3,
  GAMEOVER: 4,
  GAMEEND_ANIMATION: 5,
};

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.GameScene = function () {
    EHDI.Scene.call(this);
  };

EHDI.scene.GameScene.prototype = Object.create(EHDI.Scene.prototype);

EHDI.scene.GameScene.prototype.screenWillAppear = function () {
  this.init();
}

EHDI.scene.GameScene.prototype.popUpWillAppear = function() {
  EHDI.GAME.soundManager.pauseBGM();
  EHDI.GAME.soundManager.pauseAllSFX();
};

EHDI.scene.GameScene.prototype.popUpDidDisappear = function() {
  EHDI.GAME.soundManager.resumeBGM();
  EHDI.GAME.soundManager.resumeAllSFX();
};

EHDI.scene.GameScene.prototype.screenDidAppear = function () {
  
  this.startGame();
  if(EHDI.GAME.saveData.isFirstTimePlay)
  {
    this._handler_pauseGame();
    EHDI.GAME.saveData.isFirstTimePlay = false;
    EHDI.GAME.storageManager.setLocalInfo( EHDI.GAME.id, EHDI.GAME.saveData );
    /* EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
          console.log("data saved.");
      }); */ 
    EHDI.GAME.pauseButton.isPaused = true;
    EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
  }
};

EHDI.scene.GameScene.prototype.screenDidDisappear = function () {
  this.destroy();
}

EHDI.scene.GameScene.prototype.init = function () {
    this.initProps();
    this.initUtils();
    this.initGraphics();
    this.initListeners();
  };

EHDI.scene.GameScene.prototype.initProps = function () {
  this._gameState;
  this._gameWidth = 1024;
  this._gameHeight = 600;

  this._deltaTotal = 0;
  this._deltaLimit = 25;
  this._deltaMultiplier = 0;

  this._birdAnimationCount = Math.floor(Math.random() * 3);

  this._prevRavenLevelPos = 1;
  this._currentGameTime = 0;
  this._gameLevel = 1;
  this._gameScore = 10;
  this._ravenBaseSpawnDelay = 1000;
  this._ravenCurrentSpawnDelay = this._ravenBaseSpawnDelay;
  this._obstacleBaseSpawnDelay = 2000;
  this._obstacleCurrentSpawnDelay = this._obstacleBaseSpawnDelay;

  this._ravenSpawnDelay;
  this._obstacleSpawnDelay;

  this._prevState;
  this._gameState = EHDI.GameStateEnum.GAMEINITIALIZING;
};

EHDI.scene.GameScene.prototype.initUtils = function () {
  this._ravenSpawnTimer;
  this._obstacleSpawnTimer;
  this._scoreTimer;

  if (this._ravenSpawnTimer == null) {
    this._ravenSpawnTimer = new EHDI.util.Time();
  }

  if (this._obstacleSpawnTimer == null) {
    this._obstacleSpawnTimer = new EHDI.util.Time();
  }

  if (this._scoreTimer == null) {
    this._scoreTimer = new EHDI.util.Time();
  }
};

EHDI.scene.GameScene.prototype.destroyUtils = function () {
  if (this._ravenSpawnTimer != null) {
    this._ravenSpawnTimer.destroy();
    this._ravenSpawnTimer = null;
  }

  if (this._obstacleSpawnTimer != null) {
    this._obstacleSpawnTimer.destroy();
    this._obstacleSpawnTimer = null;
  }

  if (this._scoreTimer != null) {
    this._scoreTimer.destroy();
    this._scoreTimer = null;
  }
}

EHDI.scene.GameScene.prototype.initGraphics = function () {
  this._hudContainer;
  this._backgroundContainer;
  this._gameContainer;
  this._foregroundContainer;

  this._character;
  // this._backgroundTilingSprite;
  // this._backgroundTexture;
  this._skyTexture;
  this._skySprite;
  // this._background1Texture;
  // this._background1Sprite;
  this._cloudTexture;
  this._cloudSprite;

  this._floodEffect;

  this._activeRavens = [];
  this._ravensToRemove = [];

  this._activeObstacles = [];
  this._obstaclesToRemove = [];

  if (this._backgroundContainer == null) {
    this._backgroundContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._backgroundContainer);
  }

  if (this._skyTexture == null) {
    this._skyTexture = EHDI.Assets.images['bg_sky'];
  }

  if (this._skySprite == null) {
    this._skySprite = new EHDI.aka.Sprite(this._skyTexture);

    this._backgroundContainer.addChild(this._skySprite);
  }

  // if (this._background1Texture == null) {
  //   this._background1Texture = EHDI.Assets.images['bg_behindwater'];
  // }

  // if (this._background1Sprite == null) {
  //   this._background1Sprite = new EHDI.aka.TilingSprite
  //   (this._background1Texture, this._gameWidth , this._background1Texture.height);
  //
  //   this._background1Sprite.y = this._gameHeight - this._background1Texture.height;
  //
  //   this._backgroundContainer.addChild(this._background1Sprite);
  // }

  if (this._cloudTexture == null) {
    this._cloudTexture = EHDI.Assets.images['bg_clouds'];
  }

  if (this._cloudSprite == null) {
    this._cloudSprite = new EHDI.aka.TilingSprite
    (this._cloudTexture, this._gameWidth , this._cloudTexture.height - 2);

    this._backgroundContainer.addChild(this._cloudSprite);
  }
  // if (this._backgroundTexture == null) {
  //   this._backgroundTexture = EHDI.Assets.images['bg_dove'];
  // }

  // if (this._backgroundTilingSprite == null) {
  //   this._backgroundTilingSprite = new EHDI.aka.TilingSprite(this._backgroundTexture, 1024, 600);
  //
  //   this._backgroundContainer.addChild(this._backgroundTilingSprite);
  // }

  if (this._gameContainer == null) {
    this._gameContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._gameContainer);
  }

  if (this._character == null) {
    this._character = EHDI.GetGlobalPool().charPool.get();
    this._character.init();
    this._characterAnimationCompletedWithBind = this._handler_characterAnimationCompleted.bind(this);
    this._character.on('ANIMATION_COMPLETED', this._characterAnimationCompletedWithBind);
    this._gameContainer.addChild(this._character);
  }

  if (this._foregroundContainer == null) {
    this._foregroundContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._foregroundContainer);
  }

  if (this._floodEffect == null) {
    this._floodEffect = EHDI.GetGlobalPool().effectPool.get();

    this._floodEffect.init('fx_flood');

    this._floodEffect.updatePos(512, 600)

    this._floodEffect.changeAnimation();

    this._foregroundContainer.addChild(this._floodEffect.getDisplay());
  }

  if (this._hudContainer == null) {
    this._hudContainer = EHDI.GetGlobalPool().containerPool.get();

    this.addChild(this._hudContainer);
  }

  if (this._scoreContainer == null) {
    this._scoreContainer = new EHDI.components.ScoreManager(this._hudContainer);
    this._scoreContainer.setXY(10,10);
  }

  if (this._hudPauseButton == null) {
    this._hudPauseButton = new EHDI.components.pauseButton();

    this._hudContainer.addChild(this._hudPauseButton);
  }
};

EHDI.scene.GameScene.prototype.destroyGraphics = function () {
  if (this._hudPauseButton != null) {
    this._hudContainer.removeChild(this._hudPauseButton);
    this._hudPauseButton = null;
  }

  if (this._scoreContainer != null) {
    this._scoreContainer.dispose();
    this._scoreContainer = null;
  }

  if(this._hudContainer != null)
  {
    this.removeChild(this._hudContainer);
    this._hudContainer.destroy({children: true});
  }
  this._hudContainer = null;

  if(this._floodEffect != null)
  {
    this._foregroundContainer.removeChild(this._floodEffect);
    this._floodEffect.reset();
  }
  this._floodEffect = null;

  if(this._foregroundContainer != null)
  {
    this.removeChild(this._foregroundContainer);
    this._foregroundContainer.destroy({children: true});
  }
  delete this._foregroundContainer;

  if (this._character != null) {
    this._gameContainer.removeChild(this._character);
    this._character.removeListener('ANIMATION_COMPLETED', this._characterAnimationCompletedWithBind);
    this._character.stopAnimation();
    // EHDI.GetGlobalPool().charPool.return(this._character);
    this._character = null;
  }


  // if (this._backgroundTilingSprite != null) {
  //   this._backgroundContainer.removeChild(this._backgroundTilingSprite);
  //   this._backgroundTilingSprite = null;
  // }

  this.removeRaven();

  while (this._activeRavens.length > 0)
  {
    var raven = this._activeRavens.pop();

    this._gameContainer.removeChild(raven);

    // raven.dispose();
    EHDI.GetGlobalPool().ravenPool.return(raven);

    raven = null;
  }

  this.removeObstacle();

  while (this._activeObstacles.length > 0)
  {
    var obstacle = this._activeObstacles.pop();

    this._gameContainer.removeChild(obstacle);

    EHDI.GetGlobalPool().obstaclePool.return(obstacle);
    obstacle = null;
  }

  if(this._gameContainer != null)
  {
    this.removeChild(this._gameContainer);
    this._gameContainer.destroy({children: true});
  }
  this._gameContainer = null;

  if(this._cloudSprite != null)
  {
    this._backgroundContainer.removeChild(this._cloudSprite);
    this._cloudSprite.destroy({children: true});
  }
  this._cloudSprite = null;

  if(this._skySprite != null)
  {
    this._backgroundContainer.removeChild(this._skySprite);
    this._skySprite.destroy({children: true});
  }
  this._skySprite = null;

  if(this._backgroundContainer != null)
  {
    this.removeChild(this._backgroundContainer);
    this._backgroundContainer.destroy({children: true});
  }
  this._backgroundContainer = null;
};

EHDI.scene.GameScene.prototype.initListeners = function () {
  if (this._ticker == null) {
    this._ticker = new EHDI.aka.Ticker();
  }

  if (this.updateWithBind == null)
    this.updateWithBind = this.update.bind(this);

  this._ticker.add(this.updateWithBind);
  this._ticker.start();

  if (EHDI.BrowserInfo.isMobileDevice) {
    this.interactive = true;
    this.onTouchWithBind = this._handler_onTouch.bind(this);
    this.on('pointerdown', this.onTouchWithBind);
  } else {
    this.onKeyWithBind = this._handler_onKeyDown.bind(this);
    window.addEventListener('keydown', this.onKeyWithBind);
  }

  this.onPauseWithBind = this._handler_pauseGame.bind(this);
  this.onResumeWithBind = this._handler_resumeGame.bind(this);

  this._hudPauseButton.on('PAUSE_GAME', this.onPauseWithBind);
  this._hudPauseButton.on('RESUME_GAME', this.onResumeWithBind);
};

EHDI.scene.GameScene.prototype.destroyListeners = function () {
  
  this._ticker.remove(this.updateWithBind);
  this._ticker.stop();

  if (EHDI.BrowserInfo.isMobileDevice) {
    this.interactive = false;
    this.off('pointerdown', this.onTouchWithBind);
  } else {
    window.removeEventListener('keydown', this.onKeyWithBind);
  }

  if(this._hudPauseButton != null)
  {

    this._hudPauseButton.removeListener('PAUSE_GAME', this.onPauseWithBind);
    this._hudPauseButton.removeListener('RESUME_GAME', this.onResumeWithBind);

  }
  
  
};

EHDI.scene.GameScene.prototype.startGame = function () {
  this._character.start();
  this._character.fly();

  this._floodEffect.play();
  this.spawnRaven();
  this.spawnObstacle();

  this.gameStateManager(EHDI.GameStateEnum.GAMESTARTED);

  this._scoreTimer.reset();
};

EHDI.scene.GameScene.prototype.gameStateManager = function (newState) {
  if (this._gameState != newState) {
    if (newState == EHDI.GameStateEnum.GAMEEND_ANIMATION) {
      this._hudPauseButton.endGame();
    }
    this._gameState = newState;
  }
};

EHDI.scene.GameScene.prototype.getStar = function (score) {
  if (score >= 1500)
    return 3;
  else if (score >= 800)
    return 2;
  else if (score >= 500)
    return 1;
  else {
    return 0;
  }
}

EHDI.scene.GameScene.prototype.update = function (delta) {
  this._deltaTotal += delta * 25;
  if (this._deltaTotal >= this._deltaLimit) {
    this._deltaMultiplier = Math.floor(this._deltaTotal / this._deltaLimit);

    for (var i = 0; i < this._deltaMultiplier; i++) {
      this.gameUpdate(this._deltaLimit);
    }

    this._deltaTotal -= (this._deltaMultiplier * this._deltaLimit);
  }

  if (this._gameState == EHDI.GameStateEnum.GAMESTARTED) {
    this.updateScore();
    this.updateLevel();
  }
};

EHDI.scene.GameScene.prototype.spawnObstacle = function () {
  var obstacle = EHDI.GetGlobalPool().obstaclePool.get();

  if(obstacle != null)
  {
    obstacle.init();
    obstacle.start();
  
    this._activeObstacles.push(obstacle);
    this._gameContainer.addChild(obstacle);
  
    this._obstacleSpawnTimer.reset();
    this.randomizeObstacleSpawnTime();
  }
  
}

EHDI.scene.GameScene.prototype.randomizeObstacleSpawnTime = function () {
  this._obstacleSpawnDelay = this._obstacleCurrentSpawnDelay + Math.random() * this._obstacleCurrentSpawnDelay;
}

EHDI.scene.GameScene.prototype.spawnRaven = function () {
  var raven = EHDI.GetGlobalPool().ravenPool.get();

  this._birdAnimationCount++;
  if (this._birdAnimationCount >= 3)
    this._birdAnimationCount = 0;

  if(raven != null)
  {
    raven.init(this._birdAnimationCount);

    this._prevRavenLevelPos = raven.start(this._prevRavenLevelPos);
  
    this._activeRavens.push(raven);
    this._gameContainer.addChild(raven);
  
    this._ravenSpawnTimer.reset();
    this.randomizeRavenSpawnTime();
  }
  
}

EHDI.scene.GameScene.prototype.randomizeRavenSpawnTime = function () {
  this._ravenSpawnDelay = this._ravenCurrentSpawnDelay + Math.random() * this._ravenCurrentSpawnDelay;
}

EHDI.scene.GameScene.prototype.gameUpdate = function (delta) {
  if (this._gameState != EHDI.GameStateEnum.GAMEPAUSED) {
    dragonBones.WorldClock.clock.advanceTime(delta * 0.001);

    if (this._gameState == EHDI.GameStateEnum.GAMESTARTED) {
      this.updateBackground(delta);

      this.updateRavens(delta);
      this.updateObstacles(delta);
      this._character.update(delta);

      this.checkCharAndRavenCollision();
      this.checkCharAndObstacleCollision();

      if (this._ravenSpawnTimer.getPercentageOfCurrentTimeOverGivenTime(this._ravenSpawnDelay) == 1) {
        this.spawnRaven();
      }

      if (this._obstacleSpawnTimer.getPercentageOfCurrentTimeOverGivenTime(this._obstacleSpawnDelay) == 1) {
        this.spawnObstacle();
      }
    } else if (this._gameState == EHDI.GameStateEnum.GAMEEND_ANIMATION) {
      this.updateRavens(delta);
      this._character.update(delta);
    }
  }
};

EHDI.scene.GameScene.prototype.updateScore = function () {
  var timeInSeconds = this._scoreTimer.getTimeInSeconds();

  if (this._currentGameTime < timeInSeconds) {

    this._scoreContainer.addScore((timeInSeconds - this._currentGameTime) * this._gameScore);

    this._currentGameTime = timeInSeconds;
  }
};

EHDI.scene.GameScene.prototype.updateLevel = function () {
  var timeInSeconds = this._scoreTimer.getTimeInSeconds();

  if (timeInSeconds >= 60 && this._gameLevel == 5) {
    this._gameLevel = 6;
    this._gameScore = 60;
    this._ravenCurrentSpawnDelay = this._ravenBaseSpawnDelay * 0.2;
    this._obstacleCurrentSpawnDelay = this._obstacleBaseSpawnDelay * 0.2;
    this._character.updateSpeed(this._gameLevel);
  } else if (timeInSeconds >= 40 && this._gameLevel == 4) {
    this._gameLevel = 5;
    this._gameScore = 50;
    this._ravenCurrentSpawnDelay = this._ravenBaseSpawnDelay * 0.4;
    this._obstacleCurrentSpawnDelay = this._obstacleBaseSpawnDelay * 0.4;
    this._character.updateSpeed(this._gameLevel);
  } else if (timeInSeconds >= 30 && this._gameLevel == 3) {
    this._gameLevel = 4;
    this._gameScore = 40;
    this._ravenCurrentSpawnDelay = this._ravenBaseSpawnDelay * 0.6;
    this._obstacleCurrentSpawnDelay = this._obstacleBaseSpawnDelay * 0.6;
    this._character.updateSpeed(this._gameLevel);
  } else if (timeInSeconds >= 20 && this._gameLevel == 2) {
    this._gameLevel = 3;
    this._gameScore = 30;
    this._ravenCurrentSpawnDelay = this._ravenBaseSpawnDelay * 0.75;
    this._obstacleCurrentSpawnDelay = this._obstacleBaseSpawnDelay * 0.75;
    this._character.updateSpeed(this._gameLevel);
  } else if (timeInSeconds >= 10 && this._gameLevel == 1) {
    this._gameLevel = 2;
    this._gameScore = 20;
    this._ravenCurrentSpawnDelay = this._ravenBaseSpawnDelay * 0.9;
    this._obstacleCurrentSpawnDelay = this._obstacleBaseSpawnDelay * 0.9;
    this._character.updateSpeed(this._gameLevel);
  }
}

EHDI.scene.GameScene.prototype.updateObstacles = function (delta) {
  for (var i = 0; i < this._activeObstacles.length; i++) {
    this._activeObstacles[i].update(delta, this._character.getSpeed());

    if (this._activeObstacles[i].x <= -200)
      this._obstaclesToRemove.push(this._activeObstacles[i]);
  }

  this.removeObstacle();
}

EHDI.scene.GameScene.prototype.updateRavens = function (delta) {
  for (var i = 0; i < this._activeRavens.length; i++) {
    this._activeRavens[i].update(delta, this._character.getSpeed());

    if (this._activeRavens[i].x <= -200)
      this._ravensToRemove.push(this._activeRavens[i]);
  }

  this.removeRaven();
}

EHDI.scene.GameScene.prototype.updateBackground = function (delta) {
  // this.updateBackgroundNHLimit(this._background1Sprite);
  // this._background1Sprite.tilePosition.x -= this._character.getSpeed() * 0.2 * delta;

  this.updateBackgroundNHLimit(this._cloudSprite);
  this._cloudSprite.tilePosition.x -= this._character.getSpeed() * 0.5 * delta;
}

EHDI.scene.GameScene.prototype.updateBackgroundNHLimit = function (tilingSprite) {
  if (tilingSprite.tilePosition.x < -tilingSprite.texture.width) {
    tilingSprite.tilePosition.x =
    tilingSprite.tilePosition.x + tilingSprite.texture.width;
  }
};

EHDI.scene.GameScene.prototype.checkCharAndRavenCollision = function () {
  for (var i = 0; i < this._activeRavens.length; i++) {
    raven = this._activeRavens[i];

    if (EHDI.CollisionManager.testRectCollision
    (this._character.getHitbox(), raven.getHitbox()) && !this._character.isCollided()) {
      this._character.collided();
      raven.collided();
      this.gameStateManager(EHDI.GameStateEnum.GAMEEND_ANIMATION);
    }
  }
};

EHDI.scene.GameScene.prototype.checkCharAndObstacleCollision = function () {
  for (var i = 0; i < this._activeObstacles.length; i++) {
    obstacle = this._activeObstacles[i];

    if (EHDI.CollisionManager.testRectCollision
    (this._character.getHitbox(), obstacle.getHitbox()) && !this._character.isCollided()) {
      EHDI.GAME.soundManager.playSFX("obstacle_hit");

      this._character.collided();
      this.gameStateManager(EHDI.GameStateEnum.GAMEEND_ANIMATION);
    }
  }
};

EHDI.scene.GameScene.prototype._handler_onKeyDown = function (e) {
  if (e.keyCode == 32 && this._gameState == EHDI.GameStateEnum.GAMESTARTED) {
    this._character.fly();
  }
};

EHDI.scene.GameScene.prototype.removeObstacle = function () {
  while (this._obstaclesToRemove.length > 0)
  {
    var obstacle = this._obstaclesToRemove.pop();

    var index = this._activeObstacles.indexOf(obstacle);

    if (index > -1) {
      this._activeObstacles.splice(index, 1);
    }

    obstacle.dispose();
    // EHDI.GetGlobalPool().obstaclePool.return(obstacle);

    obstacle = null;
  }
};

EHDI.scene.GameScene.prototype.stopAnimations = function () {
  for (var i = 0; i < this._activeRavens.length; i++) {
    this._activeRavens[i].stopAnimation();
  }

  this._character.stopAnimation();

  this._floodEffect.stop();
}

EHDI.scene.GameScene.prototype.removeRaven = function () {
  while (this._ravensToRemove.length > 0)
  {
    var raven = this._ravensToRemove.pop();

    var index = this._activeRavens.indexOf(raven);

    if (index > -1) {
      this._activeRavens.splice(index, 1);
    }

    raven.dispose();
    // EHDI.GetGlobalPool().ravenPool.return(raven);

    raven = null;
  }
};

EHDI.scene.GameScene.prototype._handler_pauseGame = function (e) {
  this._ravenSpawnTimer.pause(true);
  this._obstacleSpawnTimer.pause(true);
  this._scoreTimer.pause(true);

  this._prevState = this._gameState;
  this.gameStateManager(EHDI.GameStateEnum.GAMEPAUSED);
};

EHDI.scene.GameScene.prototype._handler_resumeGame = function (e) {
  this._ravenSpawnTimer.pause(false);
  this._obstacleSpawnTimer.pause(false);
  this._scoreTimer.pause(false);

  this.gameStateManager(this._prevState);
};

EHDI.scene.GameScene.prototype._handler_characterAnimationCompleted = function (e) {
  this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);

  this.stopAnimations();

  if ( !EHDI.GAME.constants.gameEndFunction ) {
    EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp
      (this.getStar(this._scoreContainer.getScore()), this._scoreContainer.getScore()),
      {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(),
      EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
  }
  else EHDI.GAME.constants.gameEndFunction();
   
  /* var score = this._scoreContainer.getScore();
  if(score > EHDI.GAME.saveData.highScore) {
      EHDI.GAME.saveData.highScore = score;
      EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
          console.log("data saved.");
      });
  }
  EHDI.sbGame.end(score); */
}

EHDI.scene.GameScene.prototype._handler_onTouch = function (e) {
  if (e.target != this._hudPauseButton && this._gameState == EHDI.GameStateEnum.GAMESTARTED) {
    this._character.fly();
  }
};

EHDI.scene.GameScene.prototype.destroy = function () {
  console.log("destroying");
  this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);
  this.destroyListeners();
  this.destroyGraphics();
  this.destroyUtils();
  EHDI.GetGlobalPool().gameScenePool.return(this);
};

EHDI.scene.GameScene.prototype.replay = function() {
  
  this.destroy();
  // EHDI.GAME.gameObject = EHDI.GetGlobalPool().gameScenePool.get();
  // EHDI.GAME.sceneManager.changeScene(EHDI.GAME.gameObject, {x : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageWidth(), 0), duration : 0.25}, true);
  this.init();
  this.startGame();
}

EHDI.scene.GameScene.prototype.dispose = function() {
  
  this.destroy();
}
